// @ts-nocheck
import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";
import publicRequest from "../../../Infra/http/public.request";

export const getGameFeedService = async (page = 1, pageSize = 10, isAuthenticated = false) => {
  const url = `${ConfEnv.API_GAME_FEED.FEED_LIST}?page=${page}&page_size=${pageSize}`;
  return isAuthenticated ? privateRequest.get(url) : publicRequest.get(url);
};

export const toggleGameFeedLikeService = async ({gameId, gameProvider}: {gameId: string; gameProvider: string}) => {
  return privateRequest.post(ConfEnv.API_GAME_FEED.TOGGLE_LIKE, {
    game_id: gameId,
    game_provider: gameProvider,
  });
};

export const getGameFeedCommentsService = async ({
  provider,
  gameId,
  page = 1,
  pageSize = 20,
}: {
  provider: string;
  gameId: string;
  page?: number;
  pageSize?: number;
}) => {
  return publicRequest.get(
    `${ConfEnv.API_GAME_FEED.COMMENTS}/${encodeURIComponent(provider)}/${encodeURIComponent(gameId)}?page=${page}&page_size=${pageSize}`
  );
};

export const addGameFeedCommentService = async ({
  gameId,
  gameProvider,
  content,
  userAlias,
}: {
  gameId: string;
  gameProvider: string;
  content: string;
  userAlias: string;
}) => {
  return privateRequest.post(ConfEnv.API_GAME_FEED.COMMENTS, {
    game_id: gameId,
    game_provider: gameProvider,
    content,
    user_alias: userAlias,
  });
};

export const deleteGameFeedCommentService = async (commentId: string) => {
  return privateRequest.delete(`${ConfEnv.API_GAME_FEED.COMMENTS}/${encodeURIComponent(commentId)}`);
};

export const getGameFeedRepliesService = async ({
  commentId,
  page = 1,
  pageSize = 20,
}: {
  commentId: string;
  page?: number;
  pageSize?: number;
}) => {
  return publicRequest.get(
    `${ConfEnv.API_GAME_FEED.COMMENTS}/${encodeURIComponent(commentId)}/replies?page=${page}&page_size=${pageSize}`
  );
};

export const addGameFeedReplyService = async ({
  commentId,
  content,
  userAlias,
}: {
  commentId: string;
  content: string;
  userAlias: string;
}) => {
  return privateRequest.post(`${ConfEnv.API_GAME_FEED.COMMENTS}/${encodeURIComponent(commentId)}/replies`, {
    content,
    user_alias: userAlias,
  });
};
